import {defineNuxtPlugin} from '#imports';
import {useLocalePrefix} from '../composables/useLocalePrefix';
import type {WithLocalePrefix} from '../types';

export default defineNuxtPlugin((): {provide: {withLocalePrefix: WithLocalePrefix}} => {
    const {withLocalePrefix} = useLocalePrefix();

    return {
        provide: {
            withLocalePrefix,
        },
    };
});
